const deDE = {
    'global': {
        'default': {
            'refresh': 'Aktualisieren',
            'all': 'Alle',
            'back': 'Zurück',
        },
    },
    'TopdataContactLoginSW6': {
        'loginLog': {
            'module': {
                'name': 'Anmelde- & Aktivitätsprotokoll',
                'title': 'Anmelde- & Aktivitätsprotokoll',
                'description': 'Protokoll von Anmeldeversuchen und Passwortrücksetzungen',
            },
            'list': {
                'title': 'Anmelde- & Aktivitätsprotokoll',
                'buttonDownloadCsv': 'CSV herunterladen',
                'exportError': 'CSV-Export fehlgeschlagen',
                'buttonClear': 'Leeren',
                'clearModalTitle': 'Anmelde- & Aktivitätsprotokoll leeren',
                'clearModalBody': 'Sind Sie sicher, dass Sie alle Protokolleinträge löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.',
                'clearModalConfirm': 'Ja, alle löschen',
                'clearSuccess': 'Anmelde- & Aktivitätsprotokoll wurde geleert',
                'clearError': 'Fehler beim Leeren des Protokolls',
                'filter': {
                    'attemptType': 'Aktivitätstyp',
                    'success': 'Status',
                },
                'searchEmailPlaceholder': 'Nach E-Mail-Adresse suchen…',
                'column': {
                    'email': 'E-Mail',
                    'attemptType': 'Aktivitätstyp',
                    'success': 'Status',
                    'errorMessage': 'Fehlermeldung',
                    'createdAt': 'Datum',
                },
            },
            'detail': {
                'title': 'Aktivitätsprotokoll-Eintrag',
                'card': {
                    'logInfo': 'Aktivitätsdetails',
                    'customerInfo': 'Kundeninformationen',
                },
                'label': {
                    'email': 'E-Mail-Adresse',
                    'attemptType': 'Aktivitätstyp',
                    'success': 'Status',
                    'errorMessage': 'Fehlermeldung',
                    'createdAt': 'Datum',
                    'ipAddress': 'IP-Adresse',
                    'userAgent': 'User Agent',
                    'customerName': 'Kundenname',
                    'customerEmail': 'Kunden-E-Mail',
                },
                'notFound': 'Eintrag nicht gefunden',
            },
            'attemptType': {
                'login': 'Anmeldung',
                'login_success_customer': 'Anmeldung (Kunde)',
                'contact_login': 'Anmeldung (Kontakt)',
                'password_reset_request': 'Passwortrücksetzung angefordert',
                'password_reset': 'Passwort zurückgesetzt',
            },
            'success': {
                '1': 'Erfolgreich',
                '0': 'Fehlgeschlagen',
            },
            'errorMessage': {
                'email_not_found': 'Kein Kunde oder Kontakt mit dieser E-Mail gefunden',
                'contact_not_found': 'Kein Kunde oder Kontakt mit dieser E-Mail gefunden',
                'customer_or_contact_not_found': 'Kein Kunde oder Kontakt mit dieser E-Mail gefunden',
                'invalid_password': 'Ungültiges Passwort',
                'parent_customer_inactive': 'Zugehöriger Kunde inaktiv',
            },
        },
    },
};

export default deDE;
